import translate from '../../core/services/translate';

export const VIEW_TITLE = translate('haulerProfile.modalTitle.view');
export const UPLOAD_TITLE = translate('haulerProfile.modalTitle.upload');
